/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ProgramService} from "../../../Services/ProgramService";
import {StreamBankContext} from "../../../App/StreamBankContext";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";
import React from "react";

export class ProgramFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			program: null
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ProgramService.GetProgram(this.props.Value)
			.then((x) => {
				this.setState({program: x.result});
			});
	}

	@autobind
	getContext() {
		let context = new StreamBankContext();

		if (this.state.program) {
			if (this.state.program.parentProgramId) {
				context = new StreamBankContext(
					(this.state.program.parentSlug || this.state.program.parentProgramId),
					(this.state.program.slug || this.state.program.programid)
				);
			} else {
				context = new StreamBankContext(
					(this.state.program.slug || this.state.program.programid)
				);
			}
		}

		return context;
	}

	@autobind
	_render() {
		let context = this.getContext();

		return <StreamBankLink Context={context} Tool={"summary"} Disabled={this.state.program == null}>
			{this.state.program ? this.state.program.name : "N/A"}
		</StreamBankLink>;
	}
}